import React, { ChangeEvent } from 'react';

export function InputCheckbox({ label, type, onChange, name, placeholder, size, checked }: { label: string, type: 'input' | 'checkbox' | 'radio' | 'textarea', onChange?: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void, name?: string, placeholder?: string, size?: string, checked?: boolean }) {
  const style = ['checkbox', 'radio'].includes(type) ? { display: 'flex' } : {};
  return (
    <div className={`col-md-${size || '12'}`}>
      <div className="form-group" style={style}>
        <input type={type} style={{ width: '10%', display: 'initial' }} className="form-control" name={name} placeholder={placeholder} id={`${type}-${label}`} onChange={onChange} checked={checked} />
        <label style={{ lineHeight: '36px', paddingLeft: '10px' }} htmlFor={`${type}-${label}`}>{label}</label>
      </div>
    </div>
  );
}

function Input({ label, type, onChange, name, placeholder, size, ...props }: { label: string, type: 'input' | 'text' | 'checkbox' | 'radio' | 'textarea', onChange?: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void, name?: string, placeholder?: string, size?: string }) {
  const style = ['checkbox', 'radio'].includes(type) ? { display: 'flex' } : {};
  return (
    <div className={`col-md-${size || '12'}`}>
      <div className="form-group" style={style}>
        {(type === 'text' || type === 'textarea') && <label className="label" htmlFor={`${type}-${label}`}>{label}</label>}
        {type === 'textarea' && (
          <textarea name="message" className="form-control" id="message" cols={30} rows={4} placeholder={placeholder} defaultValue={""} onChange={onChange} { ...props } />
        )}
        {(type === 'input' || type === 'text') && <input type="text" className="form-control" name={name} id="subject" placeholder={placeholder} onChange={onChange} { ...props } />}
        {(type === 'checkbox' || type === 'radio') && (
          <>
            <input type={type} style={{ width: '10%', display: 'initial' }} className="form-control" name={name} placeholder={placeholder} id={`${type}-${label}`} onChange={onChange} { ...props } />
            <div style={{ lineHeight: '36px', paddingLeft: '10px' }}>{label}</div>
          </>
        )}
      </div>
    </div>
  );
}

export default Input;
